import * as React from 'react';
import {
  DateTimeInput,
  Edit,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  useRecordContext,
} from 'react-admin';
import postStatusChoices from '../../../choices/post/post-status.choices';
import CustomRichTextInput from '../../components/common/CustomRichTextInput';
import TagsReferenceArrayInput from '../../components/post/TagsReferenceArrayInput';

const StoryTitle = () => {
  const record = useRecordContext<StoryType>();
  return <span>{record ? record.title : ''}</span>;
};

const StoryEdit = () => (
  <Edit title={<StoryTitle />}>
    <SimpleForm>
      <TextInput disabled source="id" label="resource.common.field.id" />
      <DateTimeInput
        source="date"
        label="resource.global.field.date"
        defaultValue={new Date()}
        isRequired
        validate={required()}
      />
      <TextInput
        source="title"
        label="resource.global.field.title"
        isRequired
        validate={required()}
      />
      <SelectInput
        source="status"
        label="resource.posts.field.status.name"
        choices={postStatusChoices}
        isRequired
        validate={required()}
      />
      <TagsReferenceArrayInput />
      <CustomRichTextInput
        source="content"
        label="resource.stories.field.content"
        isRequired
        validate={required()}
      />
    </SimpleForm>
  </Edit>
);

export default StoryEdit;
